import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 15,
	viewBox: "0 0 13 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.5 2.5H9.40625V1.40625C9.40625 1.05078 9.10547 0.75 8.75 0.75C8.36719 0.75 8.09375 1.05078 8.09375 1.40625V2.5H4.15625V1.40625C4.15625 1.05078 3.85547 0.75 3.5 0.75C3.11719 0.75 2.84375 1.05078 2.84375 1.40625V2.5H1.75C0.765625 2.5 0 3.29297 0 4.25V13C0 13.9844 0.765625 14.75 1.75 14.75H10.5C11.457 14.75 12.25 13.9844 12.25 13V4.25C12.25 3.29297 11.457 2.5 10.5 2.5ZM10.5 13.4375H1.75C1.50391 13.4375 1.3125 13.2461 1.3125 13V6H10.9375V13C10.9375 13.2461 10.7188 13.4375 10.5 13.4375Z",
		fill: "#212121"
	})]
});
const ForwardRef = forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
